import { lazy, Suspense } from "react";
import { ThemeProvider } from "./theme/ThemeContext";
import LoadingSpinner from "./components/ui/LoadingSpinner";

const AuthWrapper = lazy(() => import("./AuthWrapper"));

export default function App() {
  return (
    <ThemeProvider>
      <Suspense fallback={<LoadingSpinner fullPage message="Loading application..." />}>
        <AuthWrapper />
      </Suspense>
    </ThemeProvider>
  );
}
